import * as Yup from "yup";
import {
  PASSWORD_MAX_LENGTH,
  PASSWORD_MIN_LENGTH,
  hasSequentialDigits,
  passwordContainsUserFirstName,
} from "./passwordValidation";

const passwordValidationSchema = Yup.string()
  .min(
    PASSWORD_MIN_LENGTH,
    `A senha deve ter pelo menos ${PASSWORD_MIN_LENGTH} caracteres.`,
  )
  .max(
    PASSWORD_MAX_LENGTH,
    `A senha deve ter no máximo ${PASSWORD_MAX_LENGTH} caracteres.`,
  )
  .matches(/[A-Z]/, "A senha deve conter pelo menos uma letra maiúscula.")
  .matches(/[a-z]/, "A senha deve conter pelo menos uma letra minúscula.")
  .matches(/[0-9]/, "A senha deve conter pelo menos um número.")
  .matches(/[\W_]/, "A senha deve conter ao menos um caractere especial.")
  .test(
    "no-sequential-numbers",
    "A senha não pode conter números sequenciais.",
    value => !hasSequentialDigits(value ?? "")
  )
  .test(
    "no username in password",
    "A senha não pode conter o nome do usuário.",
    function (value) {
      const name = this.options.context?.name;

      if (passwordContainsUserFirstName(value ?? "", name)) {
        return this.createError({
          path: this.path,
          message: "A senha não pode conter o nome do usuário.",
        });
      }

      return true;
    },
  );

export { passwordValidationSchema };
